import { useQuery } from '@tanstack/react-query'
import { api } from '@astro/api'

/** GET /courses — the first few academy courses for the shop's cross-sell
 * grid. Returns [] while loading / on error / when the API has none, so the
 * section can show skeletons or hide the grid (no dummy data). */
export function useCourses(count = 3) {
  const query = useQuery({
    queryKey: ['courses', 'academy-cross-sell', count],
    queryFn: () => api.courses.list({ page: 1, per_page: count }),
    staleTime: 10 * 60 * 1000,
    select: (res) => {
      const rows = res?.data ?? []
      return (Array.isArray(rows) ? rows : []).slice(0, count)
    },
  })
  return {
    courses: query.data ?? [],
    isPending: query.isPending,
    isError: query.isError,
  }
}
